import styled from 'styled-components';

export const Link = styled.a`
	cursor: pointer;
	${({ theme }) => theme.fonts.text.text4};
	color: ${({ theme }) => theme.colors.text.brand.enabled};
`;
